import { render } from "./CardPlanList.vue?vue&type=template&id=4fd33c89"
import script from "./CardPlanList.vue?vue&type=script&lang=js"
export * from "./CardPlanList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__